"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.firstOption = exports.DropdownList = exports.LoadingMessage = exports.NoOptionsMessage = exports.Control = exports.ClearIndicator = exports.DropdownIndicator = exports.MultiValueContainerOverride = exports.DefaultTagRenderer = exports.SingleValue = exports.Input = exports.DefaultOptionRenderer = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const React = __importStar(require("react"));
const clsx_1 = require("clsx");
const react_select_1 = require("react-select");
const FontIcon_1 = __importDefault(require("../icon/FontIcon"));
const loader_1 = __importDefault(require("../loader"));
const icon_1 = require("../icon");
const __1 = require("..");
/**
 * Useful to stop propagating on mouse down events in custom renderers
 * This way Dropdown won't be opened with custom delete
 * @param e Propagated event
 */
const stopPropagation = (e) => {
    e.preventDefault();
    e.stopPropagation();
};
/** The following components are defined to override
 * the appereace of the react-select library components **/
const DefaultOptionRenderer = (props) => {
    var _a, _b, _c, _d;
    const { classNamePrefix, enableTermSearch, inputValue, mode } = props.selectProps;
    const OptionRenderer = (_a = props === null || props === void 0 ? void 0 : props.selectProps) === null || _a === void 0 ? void 0 : _a.optionRenderer;
    const isSelected = props.isSelected;
    const isSearchHeaderOption = (_b = props === null || props === void 0 ? void 0 : props.data) === null || _b === void 0 ? void 0 : _b.searchHeader;
    if ((_c = props.selectProps) === null || _c === void 0 ? void 0 : _c.autoScrollToCurrent) {
        React.useEffect(() => {
            if (props.isSelected) {
                const domItem = document.getElementById(props.innerProps.id);
                !!(domItem === null || domItem === void 0 ? void 0 : domItem.scrollIntoView) &&
                    domItem.scrollIntoView({ block: 'nearest', inline: 'nearest' });
            }
        }, [isSelected]);
    }
    const rendererProps = {
        data: props.data,
        inputValue: (_d = props.selectProps) === null || _d === void 0 ? void 0 : _d.inputValue,
    };
    return isSearchHeaderOption && enableTermSearch ? (inputValue &&
        (0, jsx_runtime_1.jsx)(react_select_1.components.Option, Object.assign({}, props, { children: (0, jsx_runtime_1.jsx)(HeaderComp, Object.assign({}, props)) }))) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: OptionRenderer ?
            (0, jsx_runtime_1.jsx)("div", { className: "tk-option", role: "option", children: (0, jsx_runtime_1.jsx)(react_select_1.components.Option, Object.assign({}, props, { children: (0, jsx_runtime_1.jsx)(OptionRenderer, Object.assign({}, rendererProps)) })) })
            : (0, jsx_runtime_1.jsx)("div", { className: "tk-option", role: "option", children: (0, jsx_runtime_1.jsx)(react_select_1.components.Option, Object.assign({}, props, { className: (0, clsx_1.clsx)(classNamePrefix && mode ? `${classNamePrefix}__option--${mode}` : null) })) }) });
};
exports.DefaultOptionRenderer = DefaultOptionRenderer;
// Specific Input to fix input not displayed in React-Select
// See https://github.com/JedWatson/react-select/issues/3068
// See https://github.com/JedWatson/react-select/discussions/4302
const Input = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const inputAlwaysDisplayed = (_a = props === null || props === void 0 ? void 0 : props.selectProps) === null || _a === void 0 ? void 0 : _a.inputAlwaysDisplayed;
    return (0, jsx_runtime_1.jsx)(react_select_1.components.Input, Object.assign({}, props, { required: (_b = props === null || props === void 0 ? void 0 : props.selectProps) === null || _b === void 0 ? void 0 : _b.required, onCopy: (_c = props === null || props === void 0 ? void 0 : props.selectProps) === null || _c === void 0 ? void 0 : _c.onCopy, onCut: (_d = props === null || props === void 0 ? void 0 : props.selectProps) === null || _d === void 0 ? void 0 : _d.onCut, onDrag: (_e = props === null || props === void 0 ? void 0 : props.selectProps) === null || _e === void 0 ? void 0 : _e.onDrag, onKeyUp: (_f = props === null || props === void 0 ? void 0 : props.selectProps) === null || _f === void 0 ? void 0 : _f.onKeyUp, isHidden: inputAlwaysDisplayed ? !inputAlwaysDisplayed : false, "aria-label": (_g = props === null || props === void 0 ? void 0 : props.selectProps) === null || _g === void 0 ? void 0 : _g.label, "aria-describedby": (_h = props === null || props === void 0 ? void 0 : props.selectProps) === null || _h === void 0 ? void 0 : _h['aria-describedby'], "aria-invalid": (_j = props === null || props === void 0 ? void 0 : props.selectProps) === null || _j === void 0 ? void 0 : _j['aria-invalid'], type: "search" }));
};
exports.Input = Input;
const SingleValue = (_a) => {
    var _b, _c;
    var { children, data, selectProps } = _a, props = __rest(_a, ["children", "data", "selectProps"]);
    const InputRenderer = selectProps === null || selectProps === void 0 ? void 0 : selectProps.tagRenderer;
    const inputValue = (_c = (_b = selectProps === null || selectProps === void 0 ? void 0 : selectProps.parentInstance) === null || _b === void 0 ? void 0 : _b.searchHeaderOption) === null || _c === void 0 ? void 0 : _c.value;
    const rendererProps = { data };
    const isSearchHeaderSelected = rendererProps.data.searchHeader;
    return ((0, jsx_runtime_1.jsx)(react_select_1.components.SingleValue, Object.assign({}, props, { children: isSearchHeaderSelected ? (0, jsx_runtime_1.jsx)("div", { children: inputValue }) : (InputRenderer ? (0, jsx_runtime_1.jsx)(InputRenderer, Object.assign({}, rendererProps)) : children) })));
};
exports.SingleValue = SingleValue;
const DefaultTagRenderer = (props) => {
    var _a;
    const TagRender = (_a = props.selectProps) === null || _a === void 0 ? void 0 : _a.tagRenderer;
    const rendererProps = { remove: props.removeProps.onClick, data: props.data };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: TagRender ?
            (0, jsx_runtime_1.jsx)("div", { onMouseDown: stopPropagation, children: (0, jsx_runtime_1.jsx)(TagRender, Object.assign({}, rendererProps)) })
            : (0, jsx_runtime_1.jsx)(react_select_1.components.MultiValue, Object.assign({}, props, { children: (0, jsx_runtime_1.jsxs)("div", { onMouseDown: stopPropagation, className: "tk-tag__container", children: [(0, jsx_runtime_1.jsx)("div", { className: "tk-tag", children: props.selectProps.getOptionLabel(props.data) }), (0, jsx_runtime_1.jsx)(FontIcon_1.default, { className: "tk-tag__close-icon", iconName: "cross-round", onClick: props.removeProps.onClick, tabIndex: 0 })] }) })) }));
};
exports.DefaultTagRenderer = DefaultTagRenderer;
const MultiValueContainerOverride = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (0, jsx_runtime_1.jsx)(react_select_1.components.MultiValueContainer, Object.assign({}, props, { children: (0, jsx_runtime_1.jsx)("div", { children: children }) }));
};
exports.MultiValueContainerOverride = MultiValueContainerOverride;
/**
 * This component controls the behavior of the expandable arrow displayed on
 * the right side of the Dropdown component.
 * Default: visible -> Simple select | hidden -> Multiple Select (isMulti prop)
 * The displayArrowIndicator prop from the Dropdown can override it
 */
const DropdownIndicator = (props) => {
    const { displayArrowIndicator, menuIsOpen } = props.selectProps;
    return !displayArrowIndicator ?
        null :
        (0, jsx_runtime_1.jsx)(react_select_1.components.DropdownIndicator, Object.assign({}, props, { innerProps: { 'data-testid': props.selectProps['data-testid'] }, children: (0, jsx_runtime_1.jsx)(icon_1.SvgIcon, { className: "tk-select__single-value", icon: menuIsOpen ? __1.Icons.DropUp : __1.Icons.DropDown }) }));
};
exports.DropdownIndicator = DropdownIndicator;
const ClearIndicator = (props) => {
    var _a, _b;
    let ariaLabel = 'clear';
    if ((_a = props === null || props === void 0 ? void 0 : props.selectProps) === null || _a === void 0 ? void 0 : _a.label) {
        ariaLabel = `${(_b = props.selectProps) === null || _b === void 0 ? void 0 : _b.label} ${ariaLabel}`;
    }
    return (0, jsx_runtime_1.jsx)(react_select_1.components.ClearIndicator, Object.assign({}, props, { children: (0, jsx_runtime_1.jsx)(FontIcon_1.default, { className: "tk-select__close-icon", iconName: "cross-round", onKeyPress: props.clearValue, tabIndex: 0, role: "button", "aria-label": ariaLabel }) }));
};
exports.ClearIndicator = ClearIndicator;
const Control = (_a) => {
    var { children, selectProps } = _a, props = __rest(_a, ["children", "selectProps"]);
    const { iconName } = selectProps;
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(react_select_1.components.Control, Object.assign({}, props, { className: "tk-select__container", children: [iconName && (0, jsx_runtime_1.jsx)(FontIcon_1.default, { iconName: iconName, className: "tk-input__icon" }), children] })) }));
};
exports.Control = Control;
const NoOptionsMessage = (_a) => {
    var { selectProps } = _a, props = __rest(_a, ["selectProps"]);
    return (0, jsx_runtime_1.jsx)(react_select_1.components.NoOptionsMessage, Object.assign({}, props, { children: (0, jsx_runtime_1.jsx)("div", { children: selectProps === null || selectProps === void 0 ? void 0 : selectProps.noOptionMessage }) }));
};
exports.NoOptionsMessage = NoOptionsMessage;
const HeaderComp = (props) => {
    const { termSearchMessage, inputValue } = props.selectProps;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(FontIcon_1.default, { iconName: "right-arrow", className: "tk-mr-1h" }), (0, jsx_runtime_1.jsxs)("span", { children: [termSearchMessage && typeof termSearchMessage === 'string'
                        ? termSearchMessage : termSearchMessage ? termSearchMessage(inputValue) : 'Search for term ', "'", inputValue, "'"] })] }));
};
/* Override default loading styles to the react-select */
const LoadingMessage = () => (0, jsx_runtime_1.jsx)("div", { className: "tk-select-loading", children: (0, jsx_runtime_1.jsx)(loader_1.default, {}) });
exports.LoadingMessage = LoadingMessage;
/* This component is used when the enableTermSearch prop
 * is activated to handle the header Option selection */
const DropdownList = (_a) => {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var { selectProps } = _a, props = __rest(_a, ["selectProps"]);
    if (selectProps === null || selectProps === void 0 ? void 0 : selectProps.enableTermSearch) {
        const select = (_c = (_b = selectProps === null || selectProps === void 0 ? void 0 : selectProps.selectRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.select;
        const selectValueSync = (_d = select === null || select === void 0 ? void 0 : select.state) === null || _d === void 0 ? void 0 : _d.selectValue;
        const selectValueAsync = (_f = (_e = select === null || select === void 0 ? void 0 : select.state) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.searchHeader;
        const { searchHeaderOption } = selectProps.parentInstance;
        const { inputValue } = selectProps;
        // Focus on first option and differenciate between Group Options and simple options
        let focusThis = (_g = props === null || props === void 0 ? void 0 : props.children[1]) === null || _g === void 0 ? void 0 : _g.props.data;
        if (focusThis === null || focusThis === void 0 ? void 0 : focusThis.options) {
            focusThis = (_j = (_h = props === null || props === void 0 ? void 0 : props.children[1].props) === null || _h === void 0 ? void 0 : _h.options[0]) === null || _j === void 0 ? void 0 : _j.data;
        }
        focusThis = focusThis || searchHeaderOption;
        // Clear the value if header option is selected
        if (selectValueSync && ((_k = selectValueSync[0]) === null || _k === void 0 ? void 0 : _k.searchHeader)) {
            select === null || select === void 0 ? void 0 : select.clearValue();
        }
        if (selectValueAsync) {
            (_l = select === null || select === void 0 ? void 0 : select.select) === null || _l === void 0 ? void 0 : _l.clearValue();
        }
        // Initially, remove the focus from the headerOption
        React.useEffect(() => {
            select === null || select === void 0 ? void 0 : select.setState({ focusedOption: null });
        }, [selectProps.selectRef]);
        // Update the focus depending on the inputValue.
        React.useEffect(() => {
            select === null || select === void 0 ? void 0 : select.setState({ focusedOption: focusThis });
            selectProps.parentInstance.searchHeaderOption.value = inputValue;
        }, [inputValue]);
        // Skip focusing on the headerOption if the inputValue is empty
        React.useEffect(() => {
            var _a, _b;
            if (((_b = (_a = select === null || select === void 0 ? void 0 : select.state) === null || _a === void 0 ? void 0 : _a.focusedOption) === null || _b === void 0 ? void 0 : _b.value) === '') {
                select === null || select === void 0 ? void 0 : select.setState({ focusedOption: focusThis });
            }
        }, [(_m = select === null || select === void 0 ? void 0 : select.state) === null || _m === void 0 ? void 0 : _m.focusedOption]);
    }
    return (0, jsx_runtime_1.jsx)(react_select_1.components.MenuList, Object.assign({ className: 'tk-mt-1 tk-mb-1' }, props, { children: props.children }));
};
exports.DropdownList = DropdownList;
exports.firstOption = {
    searchHeader: true,
    value: '',
};
